/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import { Grid, TextField } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  quarterToDate,
  convertStringDate,
  validateDateQuarter,
  compareDate,
} from '../../../../SharedModules/utilities/dateUtilities';
import {
  monthMapping,
  autoFormateDate,
  tabHighLigther,
  validateDate,
} from '../../../../SharedModules/utilities/utilities';
import {
  setSearchInput,
  getInterestRecievedReports,
  setInterestRecievedReport,
  setReduxDataOnSearchScreen,
} from '../Store/actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import {
  FROM_DATE_REQUIRED,
  TO_DATE_GREATER_THAN_FROM,
  TO_DATE_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const InterestRecievedRequest = (props) => {
  const dispatch = useDispatch();

  const { errors, isLoading, searchResult, searchScreenReduxObj } = useSelector(
    (state) => state?.sharedState?.InterestRecievedReducer
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [fromDate, setFromDate] = React.useState(
    searchScreenReduxObj?.fromDateValue || ''
  );
  const [toDate, setToDate] = React.useState(
    searchScreenReduxObj?.toDateValue || ''
  );
  const [errorList, setErrorList] = React.useState(errors);

  // Highlights the tab if any error
  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/interestRecieved', true);
    } else {
      tabHighLigther('/interestRecieved', false);
    }
  }, [JSON.stringify(errorList)]); 
  const normalizeQuarterPattern = (val = '') => {
    let v = (val || '').toString().trim().toUpperCase().replace(/\s+/g, '');
    let m = v.match(/^(20\d{2})Q([1-4])$/);
    if (m) return `${m[2]}Q${m[1]}`;
    m = v.match(/^Q([1-4])(20\d{2})$/);
    if (m) return `${m[1]}Q${m[2]}`;
    return v;
  };

  const isQuarterToken = (v = '') =>
    /^[1-4]Q(\d{2}|\d{4})$/.test((v || '').toString().trim().toUpperCase());
  //Resetting error message on input value change
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [fromDate, toDate]);

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []); 
  const handleOnBlur = (type, input) => {
  
    let value = (input || '').toString().toUpperCase().trim();
    value = normalizeQuarterPattern(value);

    if (isQuarterToken(value) && /^[1-4]Q\d{2}$/.test(value)) {
      value = autoFormateDate(value);
    }
  

    if (!isQuarterToken(value) && value) {
      value = autoFormateDate(value);
    }

    let allErrors = errorList || [];
    let fromError = [];
    let toError = [];

    if (type === 'fromDate') {
      setFromDate(value);
      dispatch(
        setReduxDataOnSearchScreen({
          ...searchScreenReduxObj,
          fromDateValue: value,
        })
      );

      if (!value) {
        fromError = [{ field: 'fromDate', message: FROM_DATE_REQUIRED }];
      } else {
        fromError = isQuarterToken(value)
          ? validateDateQuarter(value, 'fromDate') || []
          : validateDate(value, 'fromDate') || [];
      }

      allErrors = [...allErrors, ...fromError];
      if (!toDate && !fromError.length) {
        setToDate(value);
        dispatch(
          setReduxDataOnSearchScreen({
            ...searchScreenReduxObj,
            toDateValue: value,
            fromDateValue: value,
          })
        );
      }
    }

    if (type === 'toDate') {
      setToDate(value);
      dispatch(
        setReduxDataOnSearchScreen({
          ...searchScreenReduxObj,
          toDateValue: value,
        })
      );

      if (!value) {
        toError = [{ field: 'toDate', message: TO_DATE_REQUIRED }];
      } else {
        toError = isQuarterToken(value)
          ? validateDateQuarter(value, 'toDate') || []
          : validateDate(value, 'toDate') || [];
      }

      allErrors = [...allErrors, ...toError];
    } 
    const currentFromRaw = type === 'fromDate' ? value : fromDate;
    const currentToRaw = type === 'toDate' ? value : toDate;

    const hasFromErr = allErrors.some((e) => e.field === 'fromDate');
    const hasToErr = allErrors.some((e) => e.field === 'toDate');

    if (currentFromRaw && currentToRaw && !hasFromErr && !hasToErr) {
      const concreteFrom = isQuarterToken(currentFromRaw)
        ? convertStringDate(quarterToDate(currentFromRaw, 'fromDate'))
        : currentFromRaw;
      const concreteTo = isQuarterToken(currentToRaw)
        ? convertStringDate(quarterToDate(currentToRaw, 'toDate'))
        : currentToRaw; 

      if (compareDate(concreteFrom, concreteTo)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      }
    }

    setErrorList([...allErrors]);
    dispatch(setSearchInput({ errors: [...new Set(allErrors)] }));
  };
  const handleSearchClick = () => {
    let allErrors = errorList || [];
    let fromError = [];
    let toError = []; 

    const normFromRaw = normalizeQuarterPattern(fromDate || '');
    const normToRaw = normalizeQuarterPattern(toDate || '');

    const fromVal =
      isQuarterToken(normFromRaw) && /^[1-4]Q\d{2}$/.test(normFromRaw)
        ? autoFormateDate(normFromRaw)
        : isQuarterToken(normFromRaw)
        ? normFromRaw
        : autoFormateDate(normFromRaw);

    const toVal =
      isQuarterToken(normToRaw) && /^[1-4]Q\d{2}$/.test(normToRaw)
        ? autoFormateDate(normToRaw)
        : isQuarterToken(normToRaw)
        ? normToRaw
        : autoFormateDate(normToRaw);
    if (!fromVal) {
      fromError = [{ field: 'fromDate', message: FROM_DATE_REQUIRED }];
    } else {
      fromError = isQuarterToken(fromVal)
        ? validateDateQuarter(fromVal, 'fromDate') || []
        : validateDate(fromVal, 'fromDate') || [];
    }

    if (!toVal) {
      toError = [{ field: 'toDate', message: TO_DATE_REQUIRED }];
    } else {
      toError = isQuarterToken(toVal)
        ? validateDateQuarter(toVal, 'toDate') || []
        : validateDate(toVal, 'toDate') || [];
    }
    allErrors = [...allErrors, ...fromError, ...toError]; 
    const concreteFrom = isQuarterToken(fromVal)
      ? convertStringDate(quarterToDate(fromVal, 'fromDate'))
      : fromVal;
    const concreteToCandidate = toVal || fromVal;
    const concreteTo = isQuarterToken(concreteToCandidate)
      ? convertStringDate(quarterToDate(concreteToCandidate, 'toDate'))
      : concreteToCandidate;

    if (fromError.length === 0 && toError.length === 0) {
      if (compareDate(concreteFrom, concreteTo)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      }
    }

    setErrorList([...allErrors]);
    dispatch(
      setSearchInput({
        fromDateValue: fromVal,
        toDateValue: toVal,
        errors: allErrors,
        displayObj: {
          fromDateValue: fromVal,
          toDateValue: toVal,
        },
      })
    );

    if (allErrors.length === 0) {
      dispatch(setInterestRecievedReport([]));
      setSearchClicked(true);
      let fromDateValue = isQuarterToken(fromVal)
        ? convertStringDate(quarterToDate(fromVal, 'fromDate'))
        : fromVal;
      let toDateValue = isQuarterToken(toVal)
        ? convertStringDate(quarterToDate(toVal, 'toDate'))
        : toVal || fromDateValue;

      dispatch(
        getInterestRecievedReports({
          startDate: fromDateValue,
          endDate: toDateValue || fromDateValue,
        })
      );
    }
  }; 
  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));

    updateTabs.push({
      navTo: '/interestRecivedDetail',

      value: 'Interest Received Display',
    });

    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    props.history.push({
      pathname: '/interestRecivedDetail',
    });
    dispatch(clearReduxForFilterAndSort('/interestRecivedDetail'));
  }
  const updatedErrorList = errorList.map((item) => {
    return {
      ...item,
      message: item.message
        .replace('from date', 'Begin date')
        .replace('From date', 'Begin date')
        .replace('To date', 'End date')
        .replace('Start Date', 'Begin Date'),
    };
  });

  return (
    <div className='tabs-container'>
      <Spinner load={spinnerLoader} />

      <CustomSeparator
        parent1='State Reports'
        parent2='Interest Received Request'
      />

      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            updatedErrorList?.length > 0
              ? _.map(updatedErrorList, (l) => l.message)
              : []
          ),
        ]}
      />

      <div className='tab-body' />
      <div className='row'>
        <div className='col-6'>
          <Fieldset label='Date Range' required>
            <div className='form-wrapper p-0 mt-n3'>
              <div className='mui-custom-form input-md field-xl'>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label='Begin Date'
                      id='From Date'
                      placeholder=''
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10, 'aria-describedby': '' }}
                      name='From'
                      value={fromDate}
                      error={
                        updatedErrorList.filter(
                          (error) => error.field === 'fromDate'
                        )?.length > 0
                          ? 'mandate-fields'
                          : ''
                      }
                      data-testid='interest-Recieved-from-date'
                      helperText={
                        updatedErrorList.find(
                          (error) => error.field === 'fromDate'
                        )?.message
                      }
                      className='mandate-fields'
                      onBlur={(e) => handleOnBlur('fromDate', e.target.value)}
                      onChange={(e) => {
                        setFromDate(e.target.value.toUpperCase());
                        setErrorList([
                          ...errorList.filter(
                            (error) => error.field !== 'fromDate'
                          ),
                        ]);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label='End Date'
                      id='To Date'
                      data-testid='interest-Recieved-to-date'
                      placeholder=''
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                      inputProps={{ maxLength: 10, 'aria-describedby': '' }}
                      name='to'
                      value={toDate}
                      onBlur={(e) => handleOnBlur('toDate', e.target.value)}
                      onChange={(e) => {
                        setToDate(e.target.value.toUpperCase());
                        setErrorList([
                          ...errorList.filter(
                            (error) =>
                              error.field !== 'toDate' &&
                              error.field !== 'fromDate>toDate'
                          ),
                        ]);
                      }}
                      error={
                        updatedErrorList.filter(
                          (error) =>
                            error.field === 'toDate' ||
                            error.field === 'fromDate>toDate'
                        )?.length > 0
                          ? 'mandate-fields'
                          : ''
                      }
                      helperText={
                        updatedErrorList.find(
                          (error) =>
                            error.field === 'toDate' ||
                            error.field === 'fromDate>toDate'
                        )?.message
                      }
                      className='mandate-fields'
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </Fieldset>
        </div>
      </div>
      <div className='row' style={{ marginTop: 30 }}>
        <div className='btn-wrapper col-12'>
          <Button
            data-testid='interest-Recieved-search-btn'
            onClick={handleSearchClick}
            className='btn btn-success btn-search float-right'
          >
            <SVGComponent iconName='Icon-search' /> Search
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InterestRecievedRequest;
